<div class="home">
    <div class="home-content"
        *ngIf="page"
        [innerHtml]="content">
    </div>
    <div class="buttons">
        <button routerLink="/categories">Zaczynamy!</button>
    </div>
</div>